import React, { createContext, ReactNode, useEffect } from 'react';
import { isUndefined } from 'lodash';
import { useRouter } from 'next/router';
import UserRepository from '@/features/user/repository/UserRepository';
import { CurrentUserType } from '@/features/user/types/User';
import { setPostHogUser } from '@/shared/services/analytics/posthogConsent';

export type UnauthenticatedUser = { error : string } & Partial<Record<keyof CurrentUserType, never>>;
export type UserContextType = CurrentUserType | UnauthenticatedUser;

export type UserContextValue = {
    user : UserContextType;
    isLoading : boolean;
};

export const UserContext = createContext<UserContextValue>({
    user: { error: 'Not Logged In' },
    isLoading: false,
});

export type UserContextProviderType = {
    children : ReactNode;
};

export const UserContextProvider : React.FC<UserContextProviderType> = ({ children }) => {
    const { data: myProfile, isError, isLoading } = UserRepository.create().fetchCurrentUser();
    const router = useRouter();

    const user : UserContextType = (isError || isUndefined(myProfile))
        ? { error: 'Not Logged In' }
        : myProfile;

    useEffect(() => {
        setPostHogUser(isLoading ? undefined : ('error' in user ? null : user), router.pathname);
    }, [user, isLoading, router.pathname]);

    return (
        <UserContext.Provider value={{ user, isLoading }}>
            {children}
        </UserContext.Provider>
    );
};
